import { z } from 'zod';
export const RESUME_MIMES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];
export const RESUME_EXTENSIONS = ['pdf', 'doc', 'docx'];
/** Metadata for an uploaded resume file (the buffer is handled separately). */
export const resumeFileSchema = z.object({
    filename: z.string().min(1),
    mimetype: z.string().refine((m) => RESUME_MIMES.includes(m), {
        message: 'Resume must be a PDF, DOC or DOCX file',
    }),
    sizeBytes: z.number().int().positive().max(10 * 1024 * 1024, 'Resume must be <= 10 MB'),
});
/** reCAPTCHA token carried on every public form (literal dev stub locally). */
export const recaptchaTokenSchema = z.string().min(1);
//# sourceMappingURL=shared.js.map